export default class TimeConstants {
  public static readonly SNACKBAR_ALERT_DURATION = 6000;
}
